import http from "@/api/http.js";

export function requestUpdateSupersession(id, info) {
  return http.post("supersessions/add_info", { id, info }).then(data => {
    return data.data;
  });
}

export function getSupersessions(search) {
  return http.get(`supersessions?search=${search}`).then(data => {
    return data;
  });
}
